module.exports = "/_next/static/images/add-icon-mobile-9a2e8df8b6c4c2e36a876bd2c808ae19.png";